/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { ReactComponent as ImageLoginGraphic } from '../../assets/images/image_login_graphic_illustration.svg';
import { ReactComponent as ImageVideoCallGraphicIllustration } from '../../assets/images/image_video_call_graphic_illustration.svg';
import { ReactComponent as ImageLabTestConfirm } from '../../assets/images/image_lab_test_confirm.svg';
import { ReactComponent as ImageNoPendingVisit } from '../../assets/images/image_shine_home_plant_in_orange_pot.svg';
import { ReactComponent as ImageNoPatients } from '../../assets/images/image_provider_on_desk.svg';
import { ReactComponent as ImageNoCompleteVisit } from '../../assets/images/image_provider_completes_visits.svg';

type GraphicProps = {
  id: string;
  className?: string;
  onClick?: () => void;
};

const allGraphics: Record<string, (props: React.SVGProps<SVGSVGElement>) => JSX.Element | any> = {
  graphicLogin: ImageLoginGraphic,
  graphicVideoCall: ImageVideoCallGraphicIllustration,
  graphicLabTestConfirm: ImageLabTestConfirm,
  graphicNoPendingVisit: ImageNoPendingVisit,
  graphicNoPatients: ImageNoPatients,
  graphicNoCompleteVisit: ImageNoCompleteVisit,
};

function Graphic({ id, ...rest }: GraphicProps) {
  const SelectedGraphic = allGraphics[id];
  return SelectedGraphic ? <SelectedGraphic id={id} {...rest} /> : null;
}

Graphic.defaultProps = {
  className: '',
  onClick: () => false,
};

export default Graphic;
